<template>
  <Ribbon bg="gray-7">
    <div
      class="flex-container max-w-7xl mx-auto flex flex-col sm:flex-row sm:items-start sm:justify-center"
    >
      <img
        src="/assets/images/market/BambeeCertificationSeal.png"
        alt="seal"
        class="bambee-cert shrink-0 mb-8 sm:mb-0 mr-16"
        style="width: 80px"
      />
      <div class="text-block text-left">
        <TypeOverline
          :variant="$options.Typography.Overline.LARGE"
          tag="p"
          class="text-primary mb-3"
        >
          <span style="color: #481d72">THE BAMBEE GUARANTEE</span>
        </TypeOverline>
        <TypeDisplay
          :variant="$options.Typography.Display.MEGA"
          :weight="$options.Typography.Weights.REGULAR"
          class="ribbon-text leading-6"
        >
          <p class="text-primary leading-normal">
            Your HR Manager will be a certified Bambee HR professional,
            experienced with companies of your size, and trained in compliance
            and customer service. All customized HR work is included with your
            fixed, monthly cost. Any additional services you desire will have a
            clear and upfront price. Never any hidden&nbsp;fees.
          </p>
        </TypeDisplay>
      </div>
    </div>
  </Ribbon>
</template>

<script>
import { constants, TypeDisplay, TypeOverline } from '@bambeehr/pollen';
import Ribbon from './HomeRibbon';

const { Typography } = constants;
export default {
  name: 'RibbonBambeeCertification',
  Typography,
  components: {
    Ribbon,
    TypeDisplay,
    TypeOverline,
  },
  setup() {},
};
</script>

<style scoped>
.text-block {
  max-width: 884px;
}

@media screen and (max-width: 768px) {
  .ribbon-text >>> p {
    font-size: 20px;
    line-height: 28px;
  }
}

@media screen and (max-width: 480px) {
  .ribbon-text >>> p {
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
